import { routes } from "src/navigation/util"
import TaxonomyCard from 'src/common/TaxonomyCard'

function Topic({ topic, ...rest }) {
  const src = topic.photoUrl || 'https://storage.googleapis.com/projectlink-dev.appspot.com/projectlink-stacks.jpg'
  const href = `${routes.topic(encodeURI(topic.name))}`

  return (
    <TaxonomyCard
      title={topic.name}
      src={src}
      href={href}
      {...rest}
    />
  )
}

export default Topic
